/* eslint-disable react/prop-types */
import React, { memo } from 'react'
import styles from './styles.module.scss'
import { ColorPalette } from 'src/types/api'
import mobileCheckIcon from 'src/assets/icons/mobile-selection-check.svg'

interface PaletteItemProps {
  palette: ColorPalette
  index: number
  isSelected: boolean
  onSelect: (index: number) => void
  imageUrl: string
}

const PaletteItem: React.FC<PaletteItemProps> = memo(({ palette, index, isSelected, onSelect, imageUrl }) => {
  return (
    <div
      className={styles.gridItem}
      onClick={() => onSelect(index)}
      onKeyPress={(e) => e.key === 'Enter' && onSelect(index)}
      role="button"
      tabIndex={0}
      aria-label={`Select ${palette.name} color palette`}
      aria-pressed={isSelected}
    >
      <div className={`${styles.imageContainer} ${isSelected ? styles.selected : ''}`}>
        <img src={imageUrl} alt={palette.name} loading="lazy" />
        <div className={styles.overlay}>
          <span>{palette.name}</span>
        </div>
        {isSelected && <img src={mobileCheckIcon} alt="Selected" className={styles.mobileCheckIcon} />}
      </div>

      {!!palette.colors?.length && (
        <div className={styles.paletteColors}>
          {palette.colors.map((color, i) => (
            <span
              key={color.hex + i}
              className={styles.colorDot}
              style={{
                backgroundColor: color.hex,
                width: 16,
                height: 16,
                display: 'inline-block',
                borderRadius: '50%',
                marginRight: 4,
              }}
            />
          ))}
        </div>
      )}
    </div>
  )
})

PaletteItem.displayName = 'PaletteItem'

export default PaletteItem
